module.exports = __webpack_public_path__ + "img/search-hero-overflow-hyundai.314e6387.png";